import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5f9c1892"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "contract-detail__form-item3" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"16px","background":"#f2f4f8"} }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title_with_line" }, "设置签署方式", -1))
const _hoisted_4 = { class: "contract-detail__form-item2" }
const _hoisted_5 = { class: "contract-detail__form-item2" }
const _hoisted_6 = { class: "contract-detail__form-item2" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"16px","background":"#f2f4f8"} }, null, -1))
const _hoisted_8 = {
  key: 1,
  style: {"width":"100%","height":"400px"},
  "element-loading-text": "加载中..."
}

import {
  CONTRACT_TYPE,
  ContractMenuType,
  ContractType,
  taxPatternSelect,
  TradeStructureMap,
  TEMPLATE_TYPE,
  TAX_PATTERN,
  TAX_TYPE
} from './../constants/index';
import { computed, ref, toRefs, watch, nextTick } from 'vue';
import {
  BaseForm,
  BaseInput,
  BaseSelect,
  BaseFormItem,
  BaseUpload,
  XrkMessage,
  BaseRadioGroup,
  BaseRadio
} from 'xrk-components';
import { BaseDatepickerLongterm } from '@/components/base/base-datepicker-longterm/index';
import { uploadApi } from '@data-source/common/apis';
import {
  getEnterpriseList,
  getPartOptList,
  platformDicList,
  parkList
} from './../data-source/apis';
import { preview } from '@/utils/file';
import { IS_PLATFORM_TYPE_1 } from '@/config';


export default /*#__PURE__*/_defineComponent({
  __name: 'contract-detail',
  props: {
    disabled: { type: Boolean, default: () => true },
    contractType: {},
    detail: {},
    prefix: { default: '' },
    pageType: {}
  },
  setup(__props: any, { expose: __expose }) {

const props = __props;

const { disabled, contractType, detail } = toRefs(props);

let isInit = {
  0: true,
  1: true
};

/** 甲方 */
const participantsPartyAOpt = ref([]);
/** 乙方 */
const participantsPartyBOpt = ref([]);

const uploadRef = ref();
const formRef = ref();

const uploading = ref(false);

const rules = {
  contractTemplateName: [
    {
      required: true,
      message: `${props.prefix}名称不能为空`,
      trigger: 'blur'
    }
  ],
  contractType: [
    {
      required: true,
      message: `${props.prefix}类型不能为空`,
      trigger: 'change'
    }
  ],
  contractTemplateUrl: [
    {
      required: true,
      validator: (_rule: any, value: any, callback: any) => {
        if (!value?.length) {
          callback(new Error('请上传签署文件'));
        } else {
          callback();
        }
      },
      trigger: 'change'
    }
  ],
  contractAttributes: [
    {
      required: true,
      message: `请选择合同属性`,
      trigger: 'change'
    }
  ],
  indiePlatformId: [
    {
      required: true,
      message: `请选择平台标识`,
      trigger: 'change'
    }
  ],
  taxBroadType: [
    {
      required: true,
      message: `请选择完税类型`,
      trigger: 'change'
    }
  ],

  taxPattern: [
    {
      required: true,
      message: `请选择交易结构`,
      trigger: 'change'
    }
  ],
  validity: [
    {
      required: true,
      validator: (_rule: any, value: any, callback: any) => {
        if (!value?.length) {
          callback(new Error('合同有效期不能为空'));
        } else {
          callback();
        }
      },
      trigger: 'change'
    }
  ]
};

const getPartAlist = computed(() => {
  const { participantB } = formData.value;
  // 甲方选项
  return (
    participantsPartyBOpt.value?.find(item => item.id === participantB)
      ?.children || []
  );
});

const getPartBlist = computed(() => {
  const { participantA } = formData.value;
  // 乙方选项
  return (
    participantsPartyAOpt.value?.find(item => item.id === participantA)
      ?.children || []
  );
});
/**
 * @description: 平台标识下拉
 * @param {*} v
 * @returns {*}
 */
const platformMethod = async (platformName?: string) => {
  return await platformDicList({ platformName });
};

const formData = ref<any>({
  contractType: contractType.value,
  validity: [],
  contractTemplateUrl: [],
  contractTemplateName: '',
  taxPattern: '',
  taxBroadType: IS_PLATFORM_TYPE_1 ? null : 2
});

const needAgainEditContractTypes = [
  ContractType.MARKET_PERSON,
  ContractType.MARKET,
  ContractType.CHANNEL
];

const needAgainEdit = computed(() => {
  if (
    orignSignStatus.value.firstStatus === 2 &&
    orignSignStatus.value.secondStatus === 2
  ) {
    return false;
  }
  return (
    needAgainEditContractTypes.includes(+contractType.value) &&
    props.pageType === ContractMenuType.MANAGEMENT
  );
});

const platformNameSelectShow = computed(() => {
  // 平台标识下拉 只在向日葵并且是合同管理的市场服务合同展示
  return (
    IS_PLATFORM_TYPE_1 &&
    props.pageType === ContractMenuType.MANAGEMENT &&
    [ContractType.MARKET].includes(contractType.value)
  );
});

const taxPatternMap = computed(() => {
  const _TAX_PATTERN = JSON.parse(JSON.stringify(TAX_PATTERN));
  return taxPatternSelect[props.pageType][contractType.value].map(item => {
    return _TAX_PATTERN[item];
  });
});
// 默认选中第一个
formData.value.taxPattern = IS_PLATFORM_TYPE_1
  ? taxPatternMap.value[0].value
  : 4; // 独立项目只有运营基地 写死

const disabledDate = time => {
  if (props.pageType === ContractMenuType.MANAGEMENT) {
    return;
  }
  return time.getTime() < new Date().getTime() - 8.64e7;
};

const CONTRACT_TYPE_OPT = computed(() => {
  let types = [];
  if (props.pageType === ContractMenuType.TEMPLATE) {
    types = [
      ContractType.PLATFORM,
      ContractType.PROJECT,
      ContractType.MARKET_PERSON,
      ContractType.AGENCY_SERVICE
    ];
  } else {
    types = [
      ContractType.PLATFORM,
      ContractType.MARKET,
      ContractType.CHANNEL,
      ContractType.MARKET_PERSON,
      ContractType.AGENCY_SERVICE
    ];
  }
  return CONTRACT_TYPE.filter(item => types.includes(item.value));
});
const getLastStr = str => {
  const match = str.match(/.*\/([^/]*)$/);
  return match ? match[1] : '';
};
/**
 * @description: 园区下拉
 * @param {*} v
 * @returns {*}
 */
const parkRemoteMethod = async () => {
  return parkList({ proxySupplierId: formData.value.firstPartyId });
};
// 获取参与方选项
const getParticipantOpt = async val => {
  participantsPartyAOpt.value = await getPartOptList({
    type: val,
    typeOfPartyAAndPartyB: 1,
    source: +props.pageType,
    taxPattern: formData.value.taxPattern
  });
  participantsPartyBOpt.value = await getPartOptList({
    type: val,
    typeOfPartyAAndPartyB: 2,
    source: +props.pageType,
    taxPattern: formData.value.taxPattern
  });
  await nextTick();
  // 从查看进来的话不设置默认值
  if (disabled.value) {
    return;
  }
  formData.value.participantA = participantsPartyAOpt.value[0].id;
  formData.value.participantB = participantsPartyBOpt.value[0].id;
};

const orignSignStatus = ref({
  firstStatus: null,
  secondStatus: null
});

watch(
  () => detail.value,
  val => {
    if (!Object.keys(val || {}).length) {
      return;
    }
    const {
      contractTemplateUrl,
      validityStart,
      validityEnd,
      urlFileName,
      secondPartyId
    } = val;
    formData.value = {
      ...formData.value,
      ...val,
      contractTemplateUrl: contractTemplateUrl
        ? [
            {
              name: urlFileName || getLastStr(contractTemplateUrl),
              url: contractTemplateUrl
            }
          ]
        : [],
      validity: validityStart ? [validityStart, validityEnd] : []
    };
    if (props.pageType === ContractMenuType.TEMPLATE) {
      formData.value.secondPartyId = secondPartyId ? secondPartyId : 'all';
    }
    orignSignStatus.value = JSON.parse(
      JSON.stringify({
        firstStatus: val.firstStatus,
        secondStatus: val.secondStatus
      })
    );
    nextTick(() => {
      getParticipantOpt(contractType.value);
    });
  },
  {
    immediate: true
  }
);
if (!props.disabled) getParticipantOpt(contractType.value);
const onError = () => {
  XrkMessage.error('只支持 PDF 文件，单份文件小于 100M');
};

const httpRequest = async ({ file }) => {
  uploading.value = true;
  return uploadApi({ file }).then(
    res => {
      formData.value.urlFileName = res.data.fileName;
      uploading.value = false;
      return res;
    },
    err => {
      uploading.value = false;
      return Promise.reject(err);
    }
  );
};
const uploadChange = () => {
  formRef.value.validateField('contractTemplateUrl');
};

const handleTaxPatternChange = () => {
  formData.value.participantA = '';
  formData.value.participantB = '';
  formData.value.firstPartyId = '';
  formData.value.secondPartyId = '';
  getParticipantOpt(formData.value.contractType);
};

const handleValidityChange = () => {
  formRef.value.validateField('validity');
};

const handlePreview = async () => {
  const url = formData.value.contractTemplateUrl[0].url;
  preview(url);
};

__expose({
  submit: async () => {
    await formRef.value.validate();
    const {
      validity: [validityStart, validityEnd],
      firstPartyId,
      secondPartyId,
      contractTemplateUrl
    } = formData.value;
    if (
      !contractTemplateUrl.length ||
      contractTemplateUrl.some(item => !item.url)
    ) {
      XrkMessage.error('合同模板上传中，请稍后');
      throw new Error('合同模板上传中，请稍后');
    }
    const result = {
      ...formData.value,
      validityStart,
      validityEnd,
      contractTemplateUrl: contractTemplateUrl[0].url,
      firstPartyId: firstPartyId === 'all' ? null : firstPartyId,
      secondPartyId: secondPartyId === 'all' ? null : secondPartyId
    };
    delete result.validity;
    return result;
  }
});

return (_ctx: any,_cache: any) => {
  const _directive_xrk_loading = _resolveDirective("xrk-loading")!

  return (!_unref(disabled) || _unref(detail).id)
    ? (_openBlock(), _createBlock(_unref(BaseForm), {
        key: 0,
        ref_key: "formRef",
        ref: formRef,
        model: formData.value,
        "label-position": "top",
        rules: rules
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(BaseFormItem), {
            style: {"box-sizing":"border-box","padding":"0 20px"},
            prop: "contractTemplateUrl",
            label: "签署文件"
          }, {
            default: _withCtx(() => [
              _withDirectives((_openBlock(), _createBlock(_unref(BaseUpload), {
                style: {"width":"calc((100% - 20px) / 2)"},
                ref_key: "uploadRef",
                ref: uploadRef,
                disabled: !needAgainEdit.value && _unref(disabled),
                fileList: formData.value.contractTemplateUrl,
                "onUpdate:fileList": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.contractTemplateUrl) = $event)),
                "http-request": httpRequest,
                onError: onError,
                onChange: uploadChange,
                "auto-upload": true,
                multiple: false,
                accept: ['.pdf'],
                limit: 1,
                limitSize: 100,
                drag: false,
                btnText: "添加签署文件",
                uploadBtnProps: { limitOverHide: true },
                onPreview: handlePreview
              }, _createSlots({ _: 2 }, [
                (formData.value.contractTemplateUrl?.length < 1)
                  ? {
                      name: "tip",
                      fn: _withCtx(() => [
                        _createTextVNode(" 只支持 PDF 文件，单份文件小于100M ")
                      ]),
                      key: "0"
                    }
                  : undefined
              ]), 1032, ["disabled", "fileList"])), [
                [_directive_xrk_loading, uploading.value]
              ])
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_unref(BaseFormItem), {
              label: `${_ctx.prefix}类型`,
              prop: "contractType",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(BaseSelect), {
                  style: {"width":"100%","margin-top":"3px"},
                  placeholder: `请选择${_ctx.prefix}类型`,
                  options: CONTRACT_TYPE_OPT.value,
                  modelValue: formData.value.contractType,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.contractType) = $event)),
                  disabled: true
                }, null, 8, ["placeholder", "options", "modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_unref(BaseFormItem), {
              label: `${_ctx.prefix}名称`,
              prop: "contractTemplateName",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(BaseInput), {
                  style: {"width":"100%"},
                  maxlength: "50",
                  "show-word-limit": "",
                  placeholder: `请输入${_ctx.prefix}名称`,
                  disabled: _unref(disabled),
                  modelValue: formData.value.contractTemplateName,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.contractTemplateName) = $event))
                }, null, 8, ["placeholder", "disabled", "modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_unref(BaseFormItem), {
              label: "合同有效期",
              prop: "validity",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(BaseDatepickerLongterm), {
                  style: {"width":"100%","margin-top":"1px"},
                  startPlaceholder: "有效期始",
                  disabled: _unref(disabled),
                  endPlaceholder: "有效期止",
                  value: formData.value.validity,
                  "onUpdate:value": [
                    _cache[3] || (_cache[3] = ($event: any) => ((formData.value.validity) = $event)),
                    handleValidityChange
                  ],
                  "disabled-date": disabledDate
                }, null, 8, ["disabled", "value"])
              ]),
              _: 1
            }),
            (_unref(contractType) !== _unref(ContractType).CHANNEL)
              ? (_openBlock(), _createBlock(_unref(BaseFormItem), {
                  key: 0,
                  label: "合同属性",
                  prop: "contractAttributes",
                  required: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(BaseRadioGroup), {
                      disabled: _unref(disabled),
                      modelValue: formData.value.contractAttributes,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.contractAttributes) = $event))
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(TEMPLATE_TYPE), (item) => {
                          return (_openBlock(), _createBlock(_unref(BaseRadio), {
                            key: item.value,
                            value: item.value
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.label), 1)
                            ]),
                            _: 2
                          }, 1032, ["value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["disabled", "modelValue"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (platformNameSelectShow.value)
              ? (_openBlock(), _createBlock(_unref(BaseFormItem), {
                  key: 1,
                  label: "平台标识",
                  prop: "indiePlatformId",
                  required: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(BaseSelect), {
                      init: true,
                      modelValue: formData.value.indiePlatformId,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.value.indiePlatformId) = $event)),
                      disabled: _unref(disabled),
                      style: {"width":"100%"},
                      clearable: "",
                      valueKey: "indiePlatformId",
                      labelKey: "platformName",
                      filterUseRemote: "",
                      remoteMethod: platformMethod,
                      placeholder: "请选择平台标识"
                    }, null, 8, ["modelValue", "disabled"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _hoisted_2,
          _hoisted_3,
          (_unref(IS_PLATFORM_TYPE_1))
            ? (_openBlock(), _createBlock(_unref(BaseFormItem), {
                key: 0,
                style: {"box-sizing":"border-box","padding":"0 20px"},
                label: "交易结构",
                prop: "taxPattern",
                required: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(BaseRadioGroup), {
                    disabled: _unref(disabled),
                    modelValue: formData.value.taxPattern,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.value.taxPattern) = $event)),
                    onChange: handleTaxPatternChange
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(taxPatternMap.value, (item) => {
                        return (_openBlock(), _createBlock(_unref(BaseRadio), {
                          key: item.value,
                          value: item.value
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.label), 1)
                          ]),
                          _: 2
                        }, 1032, ["value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["disabled", "modelValue"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_unref(BaseFormItem), {
              label: "参与方",
              prop: "participantA",
              rules: [
          {
            required: true,
            message: '请选择参与方',
            trigger: 'change'
          }
        ]
            }, {
              default: _withCtx(() => [
                (_openBlock(), _createBlock(_unref(BaseSelect), {
                  key: getPartAlist.value.length,
                  clearable: "",
                  placeholder: "请选择",
                  filterable: false,
                  options: getPartAlist.value,
                  init: true,
                  labelKey: "name",
                  valueKey: "id",
                  modelValue: formData.value.participantA,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.value.participantA) = $event)),
                  disabled: _unref(disabled) || participantsPartyAOpt.value?.length === 1,
                  onChange: _cache[8] || (_cache[8] = 
            val => {
              if (
                val &&
                !getPartBlist.value.some(item => item.id === formData.value.participantB)
              ) {
                formData.value.participantB = '';
              }
              formData.value.firstPartyId = '';
              formRef.value.validateField('participantA');
            }
          )
                }, null, 8, ["options", "modelValue", "disabled"]))
              ]),
              _: 1
            }),
            _createVNode(_unref(BaseFormItem), {
              label: "",
              prop: "participantB",
              rules: [
          {
            required: true,
            message: '请选择参与方',
            trigger: 'change'
          }
        ]
            }, {
              default: _withCtx(() => [
                (_openBlock(), _createBlock(_unref(BaseSelect), {
                  clearable: "",
                  placeholder: "请选择",
                  filterable: false,
                  key: getPartBlist.value.length,
                  options: getPartBlist.value,
                  init: true,
                  labelKey: "name",
                  valueKey: "id",
                  modelValue: formData.value.participantB,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formData.value.participantB) = $event)),
                  disabled: _unref(disabled) || participantsPartyBOpt.value?.length === 1,
                  onChange: _cache[10] || (_cache[10] = 
            val => {
              if (
                val &&
                !getPartAlist.value.some(item => item.id === formData.value.participantA)
              ) {
                formData.value.participantA = '';
              }
              formData.value.secondPartyId = '';
              formRef.value.validateField('participantB');
            }
          )
                }, null, 8, ["options", "modelValue", "disabled"]))
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_unref(BaseFormItem), {
              prop: "firstPartyId",
              rules: [
          {
            required: true,
            message: '请选择签署方',
            trigger: 'change'
          }
        ],
              label: "签署方"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(BaseSelect), {
                  clearable: "",
                  placeholder: "请选择甲方",
                  filterUseRemote: true,
                  init: true,
                  filter: true,
                  labelKey: "name",
                  valueKey: "id",
                  remoteMethod: async (enterpriseName) => {
            
            const party = formData.value.participantA;
            const reqParams = {
              index:0,
              type: props.pageType,
              entpName: 
                _unref(disabled) && _unref(detail).firstPartyId === 'all'
                  ? _unref(detail).firstPartyName
                  : enterpriseName,
              participantValue: party,
              contractType: formData.value.contractType,
              entpId:
                _unref(detail).firstPartyId === 'all'
                  ? ''
                  : _unref(detail).firstPartyId,
                  taxPattern:formData.value.taxPattern
            };
            if (!_unref(isInit)[0]) {
              delete reqParams.entpId;
            } else {
              delete reqParams.entpName;
            }
            _unref(isInit)[0] = false;
            if (!party) {
              return {
                data: {
                  list: []
                }
              };
            }
            const entpInfo = _unref(disabled)?{
              name:_unref(detail).firstPartyName,
              id:_unref(detail).firstPartyId
            }:{}
            // 签署方-甲方不展示根据模板选择
            const res = await _unref(getEnterpriseList)(reqParams,entpInfo);

            return res;
          
          },
                  modelValue: formData.value.firstPartyId,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((formData.value.firstPartyId) = $event)),
                  disabled: _unref(disabled),
                  onVisibleChange: _cache[12] || (_cache[12] = 
            visible => {
              const party = formData.value.participantA;
              if (visible && !party) {
                _unref(XrkMessage).error('请先选择参与方');
              }
            }
          ),
                  onChange: _cache[13] || (_cache[13] = 
            () => {
              formRef.value.validateField('firstPartyId');
            }
          )
                }, null, 8, ["remoteMethod", "modelValue", "disabled"])
              ]),
              _: 1
            }),
            _createVNode(_unref(BaseFormItem), {
              prop: "secondPartyId",
              rules: [
          {
            required: true,
            message: '请选择签署方',
            trigger: 'change'
          }
        ],
              label: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(BaseSelect), {
                  clearable: "",
                  placeholder: "请选择乙方",
                  filterUseRemote: true,
                  init: true,
                  filter: true,
                  labelKey: "name",
                  valueKey: "id",
                  remoteMethod: async (enterpriseName) => {
            
            const party = formData.value.participantB;
            const reqParams = {
              index:1,
              type: props.pageType,
              entpName: 
                _unref(disabled) && _unref(detail).secondPartyId === 'all'
                  ? _unref(detail).secondPartyName
                  : enterpriseName,
              participantValue: party,
              contractType: formData.value.contractType,
              entpId:
                _unref(detail).secondPartyId === 'all'
                  ? ''
                  : _unref(detail).secondPartyId,
                  taxPattern:formData.value.taxPattern,
                  businessParkId: formData.value.businessParkId
            };
            if (!_unref(isInit)[1]) {
              delete reqParams.entpId;
            } else {
              delete reqParams.entpName;
            }
            _unref(isInit)[1] = false;
            if (!party) {
              return {
                data: {
                  list: []
                }
              };
            }
             // 合同模板-市场服务人员合同, 乙方写死 根据模板选择
            if (
              formData.value.contractType === _unref(ContractType).MARKET_PERSON &&
              props.pageType === _unref(ContractMenuType).TEMPLATE
            ) {
              return {
                data: {
                  list: [
                    {
                      id: 'all',
                      name: '根据模板选择'
                    }
                  ]
                }
              };
            }
            const entpInfo = _unref(disabled)?{
              name:_unref(detail).secondPartyName,
              id:_unref(detail).secondPartyId
            }:{}
            // 签署方-甲方不展示根据模板选择
            const res = await _unref(getEnterpriseList)(reqParams,entpInfo);

            return res;
          
          },
                  modelValue: formData.value.secondPartyId,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((formData.value.secondPartyId) = $event)),
                  disabled: 
            _unref(disabled) ||
            (_unref(contractType) === _unref(ContractType).AGENCY_SERVICE &&
              !formData.value.businessParkId)
          ,
                  onVisibleChange: _cache[15] || (_cache[15] = 
            visible => {
              const party = formData.value.participantB;
              if (visible && !party) {
                _unref(XrkMessage).error('请先选择参与方');
              }
            }
          ),
                  onChange: _cache[16] || (_cache[16] = 
            () => {
              formRef.value.validateField('secondPartyId');
            }
          )
                }, null, 8, ["remoteMethod", "modelValue", "disabled"])
              ]),
              _: 1
            }),
            (
          formData.value.contractType === _unref(ContractType).AGENCY_SERVICE &&
          formData.value.taxPattern === _unref(TradeStructureMap).PARK_INDIVIDUAL &&
          [6, 8].includes(formData.value.participantA)
        )
              ? (_openBlock(), _createBlock(_unref(BaseFormItem), {
                  key: 0,
                  label: "",
                  prop: "businessParkId",
                  rules: [
          {
            required: true,
            message: '请选择所属园区',
            trigger: 'change'
          }
        ]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(BaseSelect), {
                      disabled: _unref(disabled) || !formData.value.firstPartyId,
                      clearable: "",
                      placeholder: "请选择所属园区",
                      filterable: false,
                      init: true,
                      remoteMethod: parkRemoteMethod,
                      labelKey: "businessParkName",
                      valueKey: "businessParkId",
                      modelValue: formData.value.businessParkId,
                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((formData.value.businessParkId) = $event))
                    }, null, 8, ["disabled", "modelValue"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_6, [
            (props.pageType === _unref(ContractMenuType).MANAGEMENT)
              ? (_openBlock(), _createBlock(_unref(BaseFormItem), {
                  key: 0,
                  label: "签署状态",
                  prop: "firstStatus",
                  rules: [
          {
            required: true,
            message: '请选择签署状态',
            trigger: 'change'
          }
        ]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(BaseRadioGroup), {
                      modelValue: formData.value.firstStatus,
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((formData.value.firstStatus) = $event)),
                      disabled: !needAgainEdit.value && _unref(disabled)
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(BaseRadio), { value: 2 }, {
                          default: _withCtx(() => [
                            _createTextVNode("已签")
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(BaseRadio), { value: 0 }, {
                          default: _withCtx(() => [
                            _createTextVNode("未签")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue", "disabled"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (props.pageType === _unref(ContractMenuType).MANAGEMENT)
              ? (_openBlock(), _createBlock(_unref(BaseFormItem), {
                  key: 1,
                  label: "",
                  prop: "secondStatus",
                  rules: [
          {
            required: true,
            message: '请选择签署状态',
            trigger: 'change'
          }
        ]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(BaseRadioGroup), {
                      modelValue: formData.value.secondStatus,
                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((formData.value.secondStatus) = $event)),
                      disabled: !needAgainEdit.value && _unref(disabled)
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(BaseRadio), { value: 2 }, {
                          default: _withCtx(() => [
                            _createTextVNode("已签")
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(BaseRadio), { value: 0 }, {
                          default: _withCtx(() => [
                            _createTextVNode("未签")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue", "disabled"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          (
        _unref(IS_PLATFORM_TYPE_1) &&
        formData.value.taxPattern === 4 &&
        formData.value.contractType === _unref(ContractType).MARKET_PERSON &&
        props.pageType === _unref(ContractMenuType).TEMPLATE
      )
            ? (_openBlock(), _createBlock(_unref(BaseFormItem), {
                key: 1,
                style: {"box-sizing":"border-box","padding":"0 20px"},
                label: "完税类型",
                prop: "taxBroadType",
                required: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(BaseRadioGroup), {
                    disabled: _unref(disabled),
                    modelValue: formData.value.taxBroadType,
                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((formData.value.taxBroadType) = $event))
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(TAX_TYPE), (item) => {
                        return (_openBlock(), _createBlock(_unref(BaseRadio), {
                          key: item.value,
                          value: item.value
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.label), 1)
                          ]),
                          _: 2
                        }, 1032, ["value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["disabled", "modelValue"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _renderSlot(_ctx.$slots, "default", { formData: formData.value }),
          _hoisted_7
        ]),
        _: 3
      }, 8, ["model"]))
    : _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_8, null, 512)), [
        [_directive_xrk_loading, true]
      ])
}
}

})